import {
  Ellipsis,
  ImageViewer,
  PullToRefresh,
  Swiper,
  Image,
} from "antd-mobile";
import { sleep } from "antd-mobile/es/utils/sleep";
import Certificate from "components/alert/Certificate";
import { truncateString } from "modules/common";
import { useEffect, useRef, useState } from "react";
import Fade from "react-reveal/Fade";
import r, { api } from "../../modules/Request";
import CarbonDistribution from "../CarbonNeutralityDisclosure/CarbonDistribution";
import EmissionDetails from "../CarbonNeutralityDisclosure/EmissionDetails";
import Failure from "../CarbonNeutralityDisclosure/Failure";
import blockchain from "../CarbonNeutralityDisclosure/img/blockchain.png";
import blueQy from "../CarbonNeutralityDisclosure/img/blueQy.png";
import blueRightOutline from "../CarbonNeutralityDisclosure/img/blueRightOutline.png";
import decarbonization from "../CarbonNeutralityDisclosure/img/decarbonization .png";
import dropDown from "../CarbonNeutralityDisclosure/img/dropDown.png";
import hecha from "../CarbonNeutralityDisclosure/img/hecha.png";
import measure from "../CarbonNeutralityDisclosure/img/measure.png";
import offsetIIcon from "../CarbonNeutralityDisclosure/img/offsetIIcon.png";
import paifangxq from "../CarbonNeutralityDisclosure/img/paifangxq.png";
import title1 from "../CarbonNeutralityDisclosure/img/title1.png";
import title2 from "../CarbonNeutralityDisclosure/img/title2.png";
import title3 from "../CarbonNeutralityDisclosure/img/title3.png";
import title4 from "../CarbonNeutralityDisclosure/img/title4.png";
import title5 from "../CarbonNeutralityDisclosure/img/title5.png";
import upLogo from "../CarbonNeutralityDisclosure/img/up-logo.png";
import titleIcon from "../CarbonNeutralityDisclosure/img/z-icon.png";
import { getOrganization } from "../CarbonNeutralityDisclosure/index";
import rightarrrowicon from "./../HomePage/images/rightarrow.png";
import "./index.scss";

const titleIcons = [title1, title2, title3, title4, title5];
export const colors = [
  "#227EFF",
  "#00CA76",
  "#FA9237",
  "#F7C148",
  "#09B9B6",
  "#FF5660",
  "#8658FF",
  "#8DD36F",
];
export const imgColors = [
  "#DAE9FF",
  "#D6FAEC",
  "#FFEDDE",
  "#FDEABE",
  "#B1F1F0",
  "#FBDCDE",
  "#EEE7FF",
  "#DAF0D1",
];

export const EmissionColor = [
  "#227EFF",
  "#00CA76",
  "#FA9237",
  "#F7C148",
  "#09B9B6",
];
export const EmissionImgColor = [
  "linear-gradient(0deg, #227eff40 0%, #227effad 100%)",
  "linear-gradient(0deg, #00ca7640 0%, #00ca76ad 100%)",
  "linear-gradient(0deg, #fa923736 0%, #fa92378c 100%)",
  "linear-gradient(0deg, #f7c14836 0%, #f7c1488c 100%)",
  "linear-gradient(0deg, #09b9b640 0%, #09b9b6ad 100%)",
];

function replaceSizeWithString(inputString) {
  const regex = /<font size="(\d+)">(.*?)<\/font>/g;
  const replacement = (_, size, content) => {
    const newSize = Math.ceil((parseInt(size) * 5.6) / 70);
    return `<font style='font-size: ${newSize}rem'>${content}</font>`;
  };

  const result = inputString.replace(regex, replacement);

  return result;
}

// 判断是否在微信环境
function isWeixinBrowser() {
  const ua = window.navigator.userAgent.toLowerCase();
  return ua.indexOf("micromessenger") !== -1;
}

const urlMap = {
  t: "https://cfp-t.vecarbon.com",
  u: "https://cfp-u.vecarbon.com",
  d: "https://cfp.vecarbon.com",
};

const disposeQrCodeUrl = () => {
  const url = window.location.origin;
  let qrUrl = "";
  if (url === "https://cfp-t.vecarbon.com") {
    qrUrl = urlMap.t;
  } else if (url === "https://cfp-u.vecarbon.com") {
    qrUrl = urlMap.u;
  } else {
    qrUrl = urlMap.d;
  }
  return qrUrl;
};

export default function Index() {
  const ref = useRef(null);
  const [isScrollingUp, setIsScrollingUp] = useState(false);
  const [startY, setStartY] = useState();
  const [dataVal, setDataVal] = useState({});
  const [visible, setVisible] = useState(false);
  const [isPage, setIsPage] = useState(true);
  // type:1 | 2  1是详情版本 2简介
  const { id, type } = r.getQueryString();

  useEffect(() => {
    getDetails(id);
    // eslint-disable-next-line no-undef
    return () => {
      document.title = "上海探链科技有限公司";
    };
  }, []);

  const weChatSharing = (data) => {
    const url = window.location.href;
    // eslint-disable-next-line no-undef
    wx?.ready(function () {
      //需在用户可能点击分享按钮前就先调用
      // eslint-disable-next-line no-undef
      wx?.updateAppMessageShareData({
        title: data?.data?.pubEmissionVO?.entName, // 分享标题
        desc: "碳中和披露", // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: data?.data?.pubEmissionVO?.entLogoUrl, // 分享图标
        success: function () {
          // 设置成功
        },
        error: (err) => {
          console.log(err);
        },
      });
      // eslint-disable-next-line no-undef
      wx?.updateTimelineShareData({
        title: data?.data?.pubEmissionVO?.entName, // 分享标题
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: data?.data?.pubEmissionVO?.entLogoUrl, // 分享图标
        success: function () {
          // 设置成功
        },
      });
    });
  };

  const getDetails = async (id) => {
    const result = await r.get(`${api.GET_NEUTRALITY_FILLREVIEW}/${id}`);
    if (result.status.code === "00000") {
      document.title = result?.data?.entName;
      // eslint-disable-next-line no-undef
      if (isWeixinBrowser()) {
        weChatSharing(result);
        // eslint-disable-next-line no-undef
        // wx?.ready(function () {
        //   //需在用户可能点击分享按钮前就先调用
        //   // eslint-disable-next-line no-undef
        //   wx?.updateAppMessageShareData({
        //     title: result?.data?.pubEmissionVO?.entName, // 分享标题
        //     desc: "碳中和披露", // 分享描述
        //     link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        //     imgUrl: result?.data?.pubEmissionVO?.entLogoUrl, // 分享图标
        //     success: function () {
        //       // 设置成功
        //     },
        //     error: (err) => {
        //       console.log(err);
        //     },
        //   });
        // });
      }
      setDataVal(result?.data);
    } else {
      setDataVal({ failure: true });
    }
  };

  const handleTouchMove = (e) => {
    const deltaY = e.touches[0].clientY - startY;
    // console.log(deltaY,'deltaY')
    if (deltaY < -40) {
      setTimeout(() => {
        window.scroll(0, 0);
        setIsPage(false);
      }, 200);
    }
  };

  const handleTouchStart = (e) => {
    setStartY(e.touches[0].clientY);
  };

  if (dataVal?.failure) {
    return <Failure />;
  }

  return (
    <div className="carbon-neutrality-wrapper">
      {isPage && (
        <>
          <div className="display-page-wrapper">
            <div
              className="display-page"
              onTouchMove={handleTouchMove}
              onTouchStart={handleTouchStart}
            >
              <div className="display-page-header">
                <Fade bottom opposite>
                  <div className="company-content">
                    {dataVal?.pubEmissionVO?.entLogoUrl && (
                      <div className="display-page-header-logo">
                        <img src={dataVal?.pubEmissionVO?.entLogoUrl} alt="" />
                      </div>
                    )}
                    <div className="text">
                      <Ellipsis
                        direction="end"
                        rows={2}
                        content={dataVal?.pubEmissionVO?.entName}
                      />
                    </div>
                    <div className="company-type">
                      {dataVal?.year}年 碳中和披露
                    </div>
                    <div className="company-logo"></div>
                    <div className="company-english">
                      Carbon Neutrality Declaration
                    </div>
                  </div>
                </Fade>
              </div>
              <div className="display-page-content-animation">
                <div className="display-page-content">
                  <div className="up-logo">
                    <img src={upLogo}></img>
                  </div>
                  <div>向上滑动，查看更多披露内容</div>
                </div>
              </div>
            </div>
          </div>

          {/* <InfiniteScroll
            threshold={20}
            hasMore={true}
            loadMore={() => {
              console.log('111刷新了');
              setIsPage(false);
            }}
          /> */}
        </>
      )}
      {!isPage && (
        <>
          <PullToRefresh
            headHeight={260}
            onRefresh={async () => {
              await sleep(300);
              setIsPage(true);
            }}
            renderText={(status) => {
              return (
                <div className="pull-to-refresh-dom" style={{}}>
                  <div className="pull-to-refresh-content">
                    <img src={dropDown}></img>
                    <span>下滑返回首页</span>
                  </div>
                </div>
              );
            }}
          >
            <div className="carbon-neutrality-content-wrapper">
              <div className="emission-data-wrapper">
                <Fade bottom opposite>
                  <div className="emission-data">
                    <div className="left-data">
                      <div className="left-content">
                        <div className="left-data-content">
                          <div className="left-data-title">
                            {dataVal?.reach}
                          </div>
                          <div className="left-data-year">
                            披露年份：{dataVal?.year}年
                          </div>
                        </div>
                        <div className="left-data-value">
                          {dataVal?.reachRatio}
                          <span>%</span>
                        </div>
                        <div className="left-data-icon"></div>
                      </div>
                    </div>
                    <div className="right-data">
                      <div className="discharge">
                        <div className="discharge-title">
                          碳排放总量 (tCO₂e)
                        </div>
                        <div className="discharge-value">
                          {dataVal?.emissionCarbon || "--"}
                        </div>
                        <div className="discharge-icon"></div>
                      </div>
                      <div className="offset-value">
                        <div className="offset-value-title">
                          碳抵消总量 (tCO₂e)
                        </div>
                        <div className="offset-value-value">
                          {dataVal?.offsetCarbon || "--"}
                        </div>
                        <div className="offset-value-icon"></div>
                      </div>
                    </div>
                  </div>
                </Fade>
              </div>

              <div className="carbon-neutrality-content-list">
                <Fade bottom opposite>
                  {(dataVal?.corePicUrl && dataVal?.isPublishBig === 1) ||
                  (dataVal?.txid && dataVal?.txidUrl) ? (
                    <div className="hash-content">
                      {dataVal?.corePicUrl && dataVal?.isPublishBig === 1 && (
                        <div className="video-data">
                          {dataVal?.corePicUrl && dataVal?.coreType === "0" && (
                            <img src={dataVal?.corePicUrl} alt="" />
                          )}
                          <div className="video">
                            {dataVal?.corePicUrl && dataVal?.coreType === "1" && (
                              <video
                                controls="controls"
                                muted="muted"
                                loop="loop"
                                autoPlay
                              >
                                <source
                                  src={dataVal?.corePicUrl}
                                  type="video/mp4"
                                />
                              </video>
                            )}
                          </div>
                        </div>
                      )}

                      {dataVal?.txid && dataVal?.txidUrl ? (
                        <div
                          className="blockchain-data"
                          style={{
                            marginTop:
                              dataVal?.corePicUrl && dataVal?.isPublishBig === 1
                                ? "0.45rem"
                                : "0rem",
                          }}
                        >
                          <div className="blockchain-data-header">
                            <div className="title">
                              <img src={blockchain} alt="" />
                              <span className="title-text">区块链存证</span>
                            </div>
                            <div className="options">
                              <span
                                className="options-text"
                                onClick={() => {
                                  setVisible(true);
                                }}
                              >
                                查看证书
                              </span>
                              <span className="options-icon"></span>
                            </div>
                          </div>
                          <div className="blockchain-values">
                            <div className="detail_cz_box">
                              <p className="">Hash: </p>
                              <p className="detail_certificate_address">
                                {dataVal?.txid && truncateString(dataVal?.txid)}
                              </p>
                            </div>
                            <div
                              className="jump-box"
                              onClick={() => {
                                if (dataVal?.txidUrl) {
                                  setVisible(true);
                                }
                                // dataVal?.txidUrl &&
                                //   window.open(dataVal?.txidUrl);
                              }}
                            >
                              <img src={rightarrrowicon} alt="" />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  ) : (
                    <></>
                  )}
                </Fade>
                <Fade bottom opposite>
                  {getOrganization(
                    dataVal?.pubEmissionVO,
                    {
                      style: {
                        backgroundImage:
                          "linear-gradient(180deg, #E8EFF4 0%, #FFFFFF 100%)",
                      },
                    },
                    "1"
                  )}
                </Fade>
                <div className="gradient">
                  <CarbonDistribution
                    dataVal={{ ...dataVal?.pubEmissionVO, year: dataVal?.year }}
                    type="1"
                  />
                </div>
                {type === "1" && dataVal?.pubEmissionVO?.detailList?.length ? (
                  <div className="carbon-neutrality-content-item">
                    <div className="item-header">
                      <div className="item-title">
                        <img src={titleIcon} alt="" />
                        <span>碳排放详情</span>
                      </div>
                      <div
                        className="item-icon"
                        style={{ backgroundImage: `url(${paifangxq})` }}
                      >
                        <span>单位：tCO₂e</span>
                      </div>
                    </div>
                    <EmissionDetails
                      data={dataVal?.pubEmissionVO?.detailList}
                      type="1"
                    />
                  </div>
                ) : (
                  <></>
                )}

                {dataVal?.pubNeutralityMeasuresList?.length ? (
                  <div className="carbon-neutrality-content-item">
                    <div className="item-header">
                      <div className="item-title">
                        <img src={titleIcon} alt="" />
                        <span>减碳措施</span>
                      </div>
                      <div
                        className="item-icon"
                        style={{ backgroundImage: `url(${measure})` }}
                      ></div>
                    </div>
                    <div className="item-list-wrapper">
                      {dataVal?.pubNeutralityMeasuresList?.map((item, idx) => {
                        const colorIndex = idx % colors.length;
                        return (
                          <div className="item-value">
                            <div className="back-content">
                              <div className="back-header">
                                <div
                                  className="back-header-img"
                                  style={{
                                    backgroundImage: `url(${item?.backgroundUrl})`,
                                  }}
                                ></div>
                                <div
                                  className="item-value-header"
                                  style={{
                                    backgroundImage:
                                      EmissionImgColor[colorIndex],
                                  }}
                                >
                                  <div className="unit">减排量(tCO₂e)</div>
                                  <div className="value-text">
                                    {item?.reductionCarbon}{" "}
                                  </div>
                                </div>
                              </div>
                              <div
                                className="sub-title"
                                style={{
                                  backgroundColor: EmissionColor[colorIndex],
                                }}
                              >
                                {item?.name || "--"}
                              </div>
                              {item?.pubNeutralityMeasureDetailList?.length ? (
                                <>
                                  <div
                                    className="item-value-list"
                                    style={{
                                      borderColor: EmissionColor[colorIndex],
                                    }}
                                  >
                                    {item?.pubNeutralityMeasureDetailList?.map(
                                      (subItem) => {
                                        return (
                                          <div
                                            className="item-value-content"
                                            key={subItem?.pubNeutralityId}
                                            style={{
                                              color: EmissionColor[colorIndex],
                                            }}
                                          >
                                            <div className="item-title">
                                              {subItem?.name || ""}
                                            </div>
                                            <div className="item-value-text">
                                              {subItem?.num} {subItem?.unit}
                                              {/* <div
                                          style={{
                                            marginRight: '0.05rem',
                                            textAlign: 'right',
                                          }}
                                        >
                                          {' '}

                                        </div>
                                        <div style={{ textAlign: 'left' }}>

                                        </div> */}
                                            </div>
                                          </div>
                                        );
                                      }
                                    )}
                                  </div>
                                </>
                              ) : (
                                <></>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {dataVal?.pubNeutralityDecarburizationPlanList?.length > 0 ? (
                  <div className="carbon-neutrality-content-item">
                    <div className="item-header">
                      <div className="item-title">
                        <img src={titleIcon} alt="" />
                        <span>脱碳计划</span>
                      </div>
                    </div>
                    <div className="decarbonization-list">
                      {dataVal?.pubNeutralityDecarburizationPlanList?.map(
                        (item) => {
                          return (
                            <div className="decarbonization-item">
                              <div className="decarbonization-item-icon">
                                <img src={item?.iconObj?.url} alt="" />
                              </div>
                              <div className="decarbonization-item-value">
                                <div className="item-value-title">
                                  {item?.planName}
                                </div>
                                <div className="item-value-text">
                                  {item?.introduction}
                                </div>
                              </div>
                            </div>
                          );
                        }
                      )}
                    </div>
                    <div
                      className="item-icon"
                      style={{ backgroundImage: `url(${decarbonization})` }}
                    ></div>
                  </div>
                ) : (
                  <></>
                )}
                {dataVal?.pubNeutralityOffsetCertificateList?.length ? (
                  <div className="carbon-neutrality-content-item">
                    <div
                      className="item-icon"
                      style={{ backgroundImage: `url(${offsetIIcon})` }}
                    ></div>
                    <div className="item-header">
                      <div className="item-title">
                        <img src={titleIcon} alt="" />
                        <span>碳抵消碳核查声明</span>
                      </div>
                    </div>
                    <div className="offset-img-list">
                      {dataVal?.pubNeutralityOffsetCertificateList?.map(
                        (item, idx) => {
                          const isMarBtn =
                            idx ===
                            dataVal?.pubNeutralityOffsetCertificateList
                              ?.length -
                              1;
                          const colorIndex = idx % colors.length;
                          return (
                            <div
                              className="offset-img-item"
                              key={item?.pubNeutralityId}
                              style={{
                                marginBottom: isMarBtn ? "0rem" : "0.64rem",
                              }}
                            >
                              <div className="offset-title-content">
                                <div className="offset-title-txt">
                                  {item?.certificateName}
                                </div>
                                <div className="offset-title-img">
                                  <img src={titleIcons[colorIndex]} alt="" />
                                </div>
                              </div>
                              <div className="offset-imgs">
                                <Swiper
                                  defaultIndex={0}
                                  className={
                                    item?.certificateLogos?.length > 1
                                      ? "swiper-colol"
                                      : "swiper-empty-colol"
                                  }
                                  ref={ref}
                                >
                                  {item?.certificateLogos?.map(
                                    (subItem, index) => {
                                      return (
                                        <Swiper.Item key={item}>
                                          <div
                                            className="offset-img-item"
                                            onClick={(e) => {
                                              const imgList =
                                                item?.certificateLogos?.map(
                                                  (item) => item?.url
                                                );
                                              ImageViewer.Multi.show({
                                                images: imgList,
                                                defaultIndex: index,
                                              });
                                            }}
                                          >
                                            <img
                                              src={subItem?.url}
                                              alt=""
                                              style={{
                                                borderColor: colors[colorIndex],
                                                display: "flex",
                                              }}
                                            />
                                          </div>
                                        </Swiper.Item>
                                      );
                                    }
                                  )}
                                </Swiper>
                                {item?.certificateLogos?.length > 1 ? (
                                  <div className="offset-shadow"></div>
                                ) : (
                                  <></>
                                )}
                              </div>
                              {item?.certificateIssuanceOrg &&
                                item?.certificateLink && (
                                  <div
                                    className="container-wrapper"
                                    onClick={() => {
                                      item?.certificateLink &&
                                        window.open(item?.certificateLink);
                                    }}
                                  >
                                    <div class="container">
                                      <div class="fixed-content">由 </div>
                                      <div class="variable-content">
                                        {item?.certificateIssuanceOrg}
                                      </div>
                                      <div className="container-text">
                                        颁发，查看详情
                                      </div>
                                      <div className="container-icon">
                                        <img src={blueRightOutline} alt="" />
                                      </div>
                                    </div>
                                  </div>
                                )}
                            </div>
                          );
                        }
                      )}
                    </div>
                  </div>
                ) : (
                  <></>
                )}
                {dataVal?.pubNeutralityCertificateList?.length ? (
                  <div className="carbon-neutrality-content-item">
                    <div
                      className="item-icon"
                      style={{ backgroundImage: `url(${hecha})` }}
                    ></div>
                    <div className="item-header">
                      <div className="item-title">
                        <img src={titleIcon} alt="" />
                        <span>碳中和核查声明</span>
                      </div>
                    </div>
                    <div className="offset-img-list">
                      {dataVal?.pubNeutralityCertificateList?.map(
                        (item, idx) => {
                          const colorIndex = idx % colors.length;
                          const isMarBtn =
                            idx ===
                            dataVal?.pubNeutralityCertificateList?.length - 1;
                          return (
                            <div
                              className="offset-img-item"
                              key={item?.pubNeutralityId}
                              style={{
                                marginBottom: isMarBtn ? "0rem" : "0.64rem",
                              }}
                            >
                              <div className="offset-title-content">
                                <div className="offset-title-txt">
                                  {item?.certificateName}
                                </div>
                                <div className="offset-title-img">
                                  <img src={titleIcons[colorIndex]} alt="" />
                                </div>
                              </div>
                              <div className="offset-imgs">
                                <Swiper
                                  defaultIndex={0}
                                  // className="swiper-colol"
                                  className={
                                    item?.certificateLogos?.length > 1
                                      ? "swiper-colol"
                                      : "swiper-empty-colol"
                                  }
                                  ref={ref}
                                >
                                  {item?.certificateLogos?.map(
                                    (subItem, index) => {
                                      return (
                                        <Swiper.Item key={item}>
                                          <div
                                            className="offset-img-item swiper-img"
                                            onClick={(e) => {
                                              const imgList =
                                                item?.certificateLogos?.map(
                                                  (item) => item?.url
                                                );
                                              ImageViewer.Multi.show({
                                                images: imgList,
                                                defaultIndex: index,
                                              });
                                            }}
                                          >
                                            <img
                                              src={subItem?.url}
                                              alt=""
                                              style={{
                                                borderColor: colors[colorIndex],
                                                display: "flex",
                                              }}
                                            />
                                          </div>
                                        </Swiper.Item>
                                      );
                                    }
                                  )}
                                </Swiper>
                                {/* {item?.certificateLogos?.length > 1 ? (
                                  <div className="offset-shadow"></div>
                                ) : (
                                  <></>
                                )} */}
                              </div>
                              {item?.certificateIssuanceOrg &&
                                item?.certificateLink && (
                                  <div
                                    className="container-wrapper"
                                    onClick={() => {
                                      item?.certificateLink &&
                                        window.open(item?.certificateLink);
                                    }}
                                  >
                                    <div class="container">
                                      <div class="fixed-content">由 </div>
                                      <div class="variable-content">
                                        {item?.certificateIssuanceOrg}
                                      </div>
                                      <div className="container-text">
                                        颁发，查看详情
                                      </div>
                                      <div className="container-icon">
                                        <img src={blueRightOutline} alt="" />
                                      </div>
                                    </div>
                                  </div>
                                )}
                            </div>
                          );
                        }
                      )}
                    </div>
                  </div>
                ) : (
                  <></>
                )}

                {dataVal?.pubEmissionVO?.entInfo && (
                  <div className="carbon-neutrality-content-item">
                    <div className="item-header">
                      <div className="item-title">
                        <img src={titleIcon} alt="" />
                        <span>关于企业</span>
                      </div>
                      <div
                        className="item-icon"
                        style={{ backgroundImage: `url(${blueQy})` }}
                      ></div>
                    </div>
                    <div className="gs-content">
                      {dataVal?.pubEmissionVO?.entInfo && (
                        <div
                          dangerouslySetInnerHTML={{
                            __html: replaceSizeWithString(
                              dataVal?.pubEmissionVO?.entInfo
                            ),
                          }}
                        ></div>
                      )}
                    </div>
                  </div>
                )}
                {dataVal?.pubEmissionVO?.footLogo && (
                  <div className="data_center_logo">
                    <Image src={dataVal?.pubEmissionVO?.footLogo} />
                  </div>
                )}
                {/*<div className="signature-value">*/}
                {/*  <div className="signature-logo"></div>*/}
                {/*</div>*/}
              </div>
            </div>
          </PullToRefresh>
        </>
      )}
      <Certificate
        visible={visible}
        setVisible={setVisible}
        list={{
          certificateContent: dataVal?.certificateContent,
          certificateAddress: dataVal?.txidUrl,
          blockHeight: dataVal?.blockNumber,
          certificateTime: dataVal?.certificateTime,
          certificateSubjects: dataVal?.certificateSubjects,
          geoLocation: dataVal?.geoLocation,
        }}
      />
    </div>
  );
}
